import { observer } from 'mobx-react-lite';

import AbstractCompany from '@/assets/images/abstract-company.png';
import AbstractPerson from '@/assets/images/abstract-person.png';
import { ContactData } from '@/entities/ContactData.ts';
import { useStore } from '@/stores/StoreProvider.tsx';
import DialogBottom from '@/ui-kit/DialogBottom/DialogBottom';
import { urlifyString } from '@/utils/urlifyString';

import styles from './ContactsPopup.module.scss';

interface ContactsProps {
  contactsData: ContactData;
}

function ContactsPopup(props: ContactsProps) {
  const { contactsData } = props;
  const { isContactsPopupOpen, closeContactsPopup, blockRender } = useStore('diamondsStore');

  const isCompany = Boolean(contactsData.company);

  const [website, isWebsiteValid] = urlifyString(contactsData.website);

  function onSpringStart() {
    blockRender(true);
  }

  function onSpringEnd() {
    blockRender(false);
  }

  return (
    <DialogBottom isOpen={isContactsPopupOpen} onClose={closeContactsPopup} onSpringStart={onSpringStart} onSpringEnd={onSpringEnd}>
      <div className={styles.content}>
        <div className={styles.header}>
          <img className={styles.headerLogo} width="80" height="80" src={isCompany ? AbstractCompany : AbstractPerson} alt="" />

          <div className={styles.headerName}>
            <div className={styles.title}>{contactsData.title}</div>

            {isCompany && <div className={styles.company}>{contactsData.company}</div>}

            {!isCompany && <div className={styles.company}>{contactsData.person}</div>}
          </div>
        </div>

        {isCompany && contactsData.person && (
          <div className={styles.block}>
            <div className={styles.blockTitle}>Contact Person</div>

            <div className={styles.blockContent}>{contactsData.person}</div>
          </div>
        )}

        {contactsData.whatsapp && (
          <div className={styles.block}>
            <div className={styles.blockTitle}>Whatsapp</div>

            <div className={styles.blockContent}>
              <a target="_blank" href={`https://wa.me/${contactsData.whatsapp}`}>
                {contactsData.whatsapp}
              </a>
            </div>
          </div>
        )}

        {contactsData.email && (
          <div className={styles.block}>
            <div className={styles.blockTitle}>Email</div>

            <div className={styles.blockContent}>
              <a target="_blank" href={`mailto:${contactsData.email}`}>
                {contactsData.email}
              </a>
            </div>
          </div>
        )}

        {contactsData.phone && (
          <div className={styles.block}>
            <div className={styles.blockTitle}>Phone</div>

            <div className={styles.blockContent}>
              <a target="_blank" href={`tel:${contactsData.phone}`}>
                {contactsData.phone}
              </a>
            </div>
          </div>
        )}

        {website && (
          <div className={styles.block}>
            <div className={styles.blockTitle}>Website</div>

            <div className={styles.blockContent}>
              {isWebsiteValid ? (
                <a target="_blank" href={website}>
                  {website}
                </a>
              ) : (
                <span>{website}</span>
              )}
            </div>
          </div>
        )}

        {contactsData.address && (
          <div className={styles.block}>
            <div className={styles.blockTitle}>Address</div>

            <div className={styles.blockContent}>{contactsData.address}</div>
          </div>
        )}
      </div>
    </DialogBottom>
  );
}

export default observer(ContactsPopup);
